<template>
  <span
    class="group__status"
    v-tooltip="{ title: tooltip }"
    :class="{
      success: status === 3,
      warning: status === 2,
      pending: !status || status === 1,
    }"
  >
    <FontAwesomeIcon :icon="'fa-light fa-' + icon()" />
  </span>
  <span v-if="withLabel">{{ tooltip }}</span>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { registrationManager } from "@/services/registration/registration-manager";
import { registrationConstante } from "@/constantes/registration";
import { i18n } from "@/i18n";

export default {
  name: "TrainingGroupStatusComponent",
  props: {
    status: {
      type: Number,
      required: true,
    },
    withLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    componentType: {
      type: String,
      required: false,
      default: "group",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    tooltip() {
      if (this.componentType === "group") {
        switch (this.status) {
          case registrationManager.GROUP_STATUS_TO_VALIDATE:
            return this.$t("registration.workInProgress");
          case registrationManager.GROUP_STATUS_FINALIZED:
            return this.$t("registration.valid");
          default:
            return this.$t("registration.pending");
        }
      } else {
        return i18n.global.t("registration.contract_status." + registrationConstante.REGISTRATION_STATUS[this.status]);
      }
    },
  },
  methods: {
    icon() {
      switch (this.status) {
        case registrationManager.GROUP_STATUS_TO_VALIDATE:
          return "info";
        case registrationManager.GROUP_STATUS_FINALIZED:
          return "check";
        default:
          return "timer";
      }
    },
  },
  components: { FontAwesomeIcon },
};
</script>

<style lang="scss" scoped>
.group {
  border: 1px solid $m_color_4;
  padding: 15px;
  border-radius: $radius;

  &__title {
    font-size: 16px;
    margin-bottom: 0;
  }

  &__registrations {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed $m_color_4;
  }

  &__registration {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__registration + &__registration {
    margin-top: 5px;
  }

  &__comment {
    white-space: pre;
  }

  &__status {
    background: var(--registration-waiting);
    color: $white;
    width: 23px;
    height: 23px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    border-radius: 50%;
    margin-right: 5px;

    &.success {
      background: var(--registration-success);
    }

    &.warning {
      background: var(--registration-progress);
    }
  }

  .btnCopy svg {
    width: 17px;
  }
}
</style>
